import React, { useEffect, useState } from "react";
import { fetchAlteracoes, countAlteracoes } from "../../../API/fetchAlteracoes";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
  Card,
  CardContent,
  Button,
  IconButton,
  Collapse,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import styles from "./VisualizarAlteracoes.module.css";
import SelectField from "../../atoms/SelectField/SelectField";
import TextField from "@mui/material/TextField";
import { Alteracao } from "../../../types/Alteracao";

const VisualizarAlteracoes = () => {
  const [alteracoes, setAlteracoes] = useState<Alteracao[]>([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [userTypeFilter, setUserTypeFilter] = useState<string | undefined>(
    undefined,
  );
  const [campoEditado, setCampoEditado] = useState("");
  const [totalAlteracoes, setTotalAlteracoes] = useState(0);
  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    const loadAlteracoes = async () => {
      setLoading(true);
      const data = await fetchAlteracoes(
        currentPage,
        perPage,
        searchTerm,
        userTypeFilter,
        campoEditado,
      );
      setAlteracoes(data.data);
      const total = await countAlteracoes();
      setTotalAlteracoes(total);
      setLoading(false);
    };

    loadAlteracoes();
  }, [currentPage, perPage, searchTerm, userTypeFilter, campoEditado]);

  return (
    <Card className={styles.card}>
      <CardContent>
        <h1>Histórico de Alterações ({totalAlteracoes})</h1>

        <IconButton onClick={() => setShowFilters(!showFilters)}>
          <ExpandMore />
        </IconButton>

        <Collapse in={showFilters}>
          <div className={styles.sideElement}>
            <div className={styles.element}>
              <TextField
                label="Pesquisar por nome"
                variant="standard"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={styles.filterItem}
                fullWidth
              />
            </div>
            <div className={styles.element}>
              <SelectField
                label="Filtrar por tipo de usuário"
                value={userTypeFilter || ""}
                onChange={(value) =>
                  setUserTypeFilter(value === "" ? undefined : value)
                }
                options={[
                  { nome: "Todos" },
                  { nome: "Superadmin" },
                  { nome: "Administrador" },
                  { nome: "Colaborador" },
                ]}
              />
            </div>
            <div className={styles.element}>
              <TextField
                label="Buscar por campo editado"
                variant="standard"
                value={campoEditado}
                onChange={(e) => setCampoEditado(e.target.value)}
                className={styles.filterItem}
                fullWidth
              />
            </div>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setCurrentPage(1)}
            >
              Buscar
            </Button>
          </div>
        </Collapse>

        {loading ? (
          <CircularProgress />
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Data</TableCell>
                <TableCell>Usuário</TableCell>
                <TableCell>Tipo</TableCell>
                <TableCell>Tabela</TableCell>
                <TableCell>Campo</TableCell>
                <TableCell>Valor Antigo</TableCell>
                <TableCell>Valor Novo</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {alteracoes.map((alteracao) => (
                <TableRow key={alteracao.id}>
                  <TableCell>
                    {new Date(alteracao.data_alteracao).toLocaleString()}
                  </TableCell>
                  <TableCell>{alteracao.usuario?.nome}</TableCell>
                  <TableCell>{alteracao.tipo_usuario}</TableCell>
                  <TableCell>{alteracao.tabela_editada}</TableCell>
                  <TableCell>{alteracao.campo_editado}</TableCell>
                  <TableCell>{alteracao.valor_antigo || "N/A"}</TableCell>
                  <TableCell>{alteracao.valor_novo || "N/A"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>

      <div className={styles.cardActions}>
        <div className={styles.element}>
          <SelectField
            label="Número de Alterações por página"
            value={perPage.toString() || ""}
            onChange={(value) => setPerPage(Number(value))}
            options={[{ nome: "10" }, { nome: "20" }, { nome: "30" }]}
            disableTyping
          />
        </div>
        <div className={styles.pagination}>
          <Button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(1)}
          >
            Primeira
          </Button>
          <Button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            Anterior
          </Button>
          <span>{currentPage}</span>
          <Button
            disabled={alteracoes.length < perPage}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            Próximo
          </Button>
          <Button
            disabled={alteracoes.length < perPage}
            onClick={() => setCurrentPage(Math.ceil(totalAlteracoes / perPage))}
          >
            Última
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default VisualizarAlteracoes;
